import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import AuditConstants from "../Constants/AuditConstants";

let getOperationAuditResult = [];
let auditLogInfo = [];
let auditFieldLogResult = [];
let auditObjectLogResult = [];
let searchFieldResult = [];

class AuditStore extends EventEmitter {
  emitChange(eventName) {
    this.emit(eventName);
  }

  getOperationAudit() {
    return getOperationAuditResult;
  }

  setOperationAudit(result) {
    getOperationAuditResult = result;
  }

  getOperationAuditLog() {
    return auditLogInfo;
  }

  setOperationAuditLog(result) {
    auditLogInfo = result;
  }

  getAuditFieldLog() {
    return auditFieldLogResult;
  }

  setAuditFieldLog(result) {
    auditFieldLogResult = result;
  }

  getAuditObjectLog() {
    return auditObjectLogResult;
  }

  setAuditObjectLog(result) {
    auditObjectLogResult = result;
  }

  getsearchField() {
    return searchFieldResult;
  }

  setsearchField(result) {
    searchFieldResult = result;
  }

  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case AuditConstants.GET_OPERATION_AUDIT_SUCCESS:
        this.setOperationAudit(action.result);
        break;
      case AuditConstants.GET_OPERATION_AUDIT_FAILURE:
        this.setOperationAudit(action.result);
        break;
      case AuditConstants.GET_OPERATION_AUDIT_LOG_SUCCESS:
        this.setOperationAuditLog(action.result);
        break;
      case AuditConstants.GET_OPERATION_AUDIT_LOG_FAILURE:
        this.setOperationAuditLog(action.result);
        break;
      case AuditConstants.GET_AUDIT_FIELD_LOG_SUCCESS:
        this.setAuditFieldLog(action.result);
        break;
      case AuditConstants.GET_AUDIT_FIELD_LOG_FAILURE:
        this.setAuditFieldLog(action.result);
        break;
      case AuditConstants.GET_AUDIT_OBJECT_LOG_SUCCESS:
        this.setAuditObjectLog(action.result);
        break;
      case AuditConstants.GET_AUDIT_OBJECT_LOG_FAILURE:
        this.setAuditObjectLog(action.result);
        break;
      case AuditConstants.GET_SEARCH_FIELD_SUCCESS:
        this.setsearchField(action.result);
        break;
      case AuditConstants.GET_SEARCH_FIELD_FAILURE:
        this.setsearchField(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}
const auditStore = new AuditStore();
dispatcher.register(auditStore.handleCallback.bind(auditStore));
export default auditStore;
